var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"id":"activity-finder-bookmark-feature","title":_vm._f("t")('New feature!'),"value":_vm.visibility,"narrow":""}},[_c('div',{staticClass:"bookmark-feature-modal-content"},[_c('BookmarkFeatureDescription')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }